import { Injectable } from "@angular/core";
import { Action } from "@ngrx/store";
import { SYNC_SUFFIX } from "@obg/ngrx-utils";

const ACTION_PREFIX = "[Dialog Status]";
export const DIALOG_STATUS_ACTION_TYPE = {
	open: `${ACTION_PREFIX} Open ${SYNC_SUFFIX}`,
	close: `${ACTION_PREFIX} Close ${SYNC_SUFFIX}`,
};

@Injectable({
	providedIn: "root",
})
export class DialogStatusAction {
	open(): Action {
		return {
			type: DIALOG_STATUS_ACTION_TYPE.open,
		};
	}

	close(): Action {
		return {
			type: DIALOG_STATUS_ACTION_TYPE.close,
		};
	}
}
